import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App.tsx';
import AppErrorFallback from '@/components/common/AppErrorFallback';
import '@/index.css';
import * as Sentry from '@sentry/react';
import '@/lib/sentry';
import { initAnalytics } from '@/lib/posthog';

initAnalytics();

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<AppErrorFallback />}>
            <App />
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
);
